
import { Box, Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import { InspectionPhotosMap } from "./inspectionPhotosMap";
import { InspectionDetails, InspectionPhoto, InspectionTask } from "../types/types";
import { observer } from "mobx-react";

const useStyles = makeStyles(() => ({
  textFieldRoot: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  inputRoot: {
    height: '100%',
    alignItems: 'flex-start',
  },
  inputMultiline: {
    height: '100%',
    boxSizing: 'border-box',
  },
}));

interface LocationDataProps {
  inspectionDetails: InspectionDetails;
  inspectionTask: InspectionTask;
  inspectionPhoto: InspectionPhoto;
}

export const LocationData = observer(({ inspectionDetails, inspectionTask, inspectionPhoto }: LocationDataProps) => {
  const classes = useStyles();

  return (
    <Box>
      <Typography variant="h5">Location</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box
            style={{
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "16",
              overflow: "hidden",
            }}
          >
            <InspectionPhotosMap inspectionDetails={inspectionDetails} inspectionPhotos={[inspectionPhoto]} displayPropertyArea={false} />
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box
            display="flex"
            flexDirection="column"
            gridGap="0.5rem"
            height="100%"
          >
            <Box>
              <Box display="flex" alignItems="center">
                <RoomOutlinedIcon />
                <Typography variant="h6">
                  Address
                </Typography>
              </Box>
              <Typography variant="body1">
                {inspectionDetails.propertyAddress}
              </Typography>
            </Box>

            {
              inspectionTask.comments &&
              <>
              <Typography variant="body2">Comments (optional)</Typography>

              <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <TextField
                  multiline
                  fullWidth
                  disabled
                  value={inspectionTask.comments}
                  variant="outlined"
                  className={classes.textFieldRoot}
                  InputProps={{
                    classes: {
                      root: classes.inputRoot,
                      inputMultiline: classes.inputMultiline,
                    },
                  }}
                />
              </Box>
              </>
            }

          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});